import { useState } from 'react';

const styles = {
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '8px',
        width: '100%',
        maxWidth: '260px',
        margin: '0 auto',
        padding: '12px 12px 16px 12px',
    },
    button: {
        height: '52px',
        borderRadius: '10px',
        fontWeight: 700,
        fontSize: '22px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'all 0.1s ease',
        border: 'none',
    },
    numButton: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        color: 'white',
        borderBottom: '3px solid rgba(0, 0, 0, 0.2)',
    },
    deleteButton: {
        backgroundColor: 'rgba(239, 68, 68, 0.2)',
        color: '#fecaca',
        borderBottom: '3px solid rgba(0, 0, 0, 0.2)',
    },
    submitButton: {
        backgroundColor: '#9333ea',
        color: 'white',
        borderBottom: '3px solid #581c87',
    },
};

const KeypadButton = ({ children, onClick, variant = 'num', disabled }) => {
    const [isPressed, setIsPressed] = useState(false);

    const getVariantStyle = () => {
        switch (variant) {
            case 'delete':
                return styles.deleteButton;
            case 'submit':
                return styles.submitButton;
            default:
                return styles.numButton;
        }
    };

    const buttonStyle = {
        ...styles.button,
        ...getVariantStyle(),
        ...(isPressed ? { 
            borderBottomWidth: 0, 
            transform: 'translateY(3px)' 
        } : {}),
    };

    return (
        <button
            style={buttonStyle}
            onClick={onClick}
            disabled={disabled}
            onMouseDown={() => setIsPressed(true)}
            onMouseUp={() => setIsPressed(false)}
            onMouseLeave={() => setIsPressed(false)}
            onTouchStart={() => setIsPressed(true)}
            onTouchEnd={() => setIsPressed(false)}
        >
            {children}
        </button>
    );
};

export const Keypad = ({ onPress, onDelete, onSubmit, disabled }) => {
    const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

    return (
        <div style={styles.container}>
            {keys.map((k) => (
                <KeypadButton key={k} onClick={() => onPress(k)} disabled={disabled}>
                    {k}
                </KeypadButton>
            ))}
            <KeypadButton onClick={onDelete} disabled={disabled} variant="delete">
                ⌫
            </KeypadButton>
            <KeypadButton onClick={() => onPress('0')} disabled={disabled}>
                0
            </KeypadButton>
            <KeypadButton onClick={onSubmit} disabled={disabled} variant="submit">
                ✓
            </KeypadButton>
        </div>
    );
};
